import { datadogLogs } from '@datadog/browser-logs';

interface FingerprintOpts {
  linkedId?: string;
}

type FingerprintWindow = typeof window & {
  fpPromise?: Promise<{ get?: (options: FingerprintOpts) => Promise<unknown> } | null>;
  fpLoadError?: unknown;
  fpLoadErrorLogged?: boolean;
};

export const fpGetEvent = async (options: FingerprintOpts) => {
  if (!options.linkedId) return;

  const fpWindow = window as FingerprintWindow;

  if (fpWindow.fpLoadError && !fpWindow.fpLoadErrorLogged) {
    fpWindow.fpLoadErrorLogged = true;
    datadogLogs.logger.warn('Fingerprint load failed', {
      route: window.location.pathname,
      error: JSON.stringify(fpWindow.fpLoadError),
    });
  }

  try {
    const fingerprint = await fpWindow.fpPromise;
    return await fingerprint?.get?.(options);
  } catch (error) {
    datadogLogs.logger.warn('Fingerprint get event failed', {
      route: window.location.pathname,
      error: JSON.stringify(error),
    });
    return undefined;
  }
};
